import script from "./InfoModalComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoModalComponent.vue?vue&type=script&setup=true&lang=ts"

import "./InfoModalComponent.vue?vue&type=style&index=0&id=eb086930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb086930"]])

export default __exports__